import React from "react";

export const LOGO_URL = "https://customer-assets.emergentagent.com/job_trustline-booking/artifacts/bg6bzeiu_image.png";

export default function Logo({ className = "h-9", showWordmark = true }) {
  // Inline SVG approximating the shield-with-check logo (navy + green)
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
      <svg viewBox="0 0 64 72" className="h-full" aria-hidden="true">
        <path d="M32 2 L60 12 L60 36 C60 54 44 66 32 70 C20 66 4 54 4 36 L4 12 Z"
              fill="#1B3A6B" />
        <path d="M32 6 L56 14 L56 36 C56 52 42 62 32 66 C32 66 32 6 32 6 Z"
              fill="#5BA83F" />
        <path d="M19 35 L29 45 L46 26" stroke="white" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      </svg>
      {showWordmark && (
        <div className="leading-tight">
          <div className="font-heading font-bold text-[#1B3A6B] text-lg tracking-tight">Trustline</div>
          <div className="text-[10px] uppercase tracking-[0.22em] text-[#5BA83F] font-semibold -mt-0.5">Services</div>
        </div>
      )}
    </div>
  );
}
